import { OrganizationDTO } from './OrganizationDTO'
import { Organization } from './OrganizationModel'

export const mapOrganizationsDtoToOrganizations = (organizationsDTO: OrganizationDTO[]): Organization[] => {
    return organizationsDTO as Organization[]
}
